// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "CommonRowMobile__textCenter__Ohz0o";
export const commonRowMobile = "CommonRowMobile__commonRowMobile__UZK3i";
export const line = "CommonRowMobile__line__VXzFV";
export const ctaLine = "CommonRowMobile__ctaLine__GLUoJ CommonRowMobile__line__VXzFV";
export const leftAligned = "CommonRowMobile__leftAligned__3YXBj";
export const rightAligned = "CommonRowMobile__rightAligned__4MA6d";
export const linePart = "CommonRowMobile__linePart__OWtKB";
export const left = "CommonRowMobile__left__pDWzo";
export const right = "CommonRowMobile__right__qJ7SP";
export const title = "CommonRowMobile__title__O85+d";
export const subtitle = "CommonRowMobile__subtitle__H-Y0X";
export const value = "CommonRowMobile__value__EY8Mx";
export const subvalue = "CommonRowMobile__subvalue__kgcM9";
export const spanRow = "CommonRowMobile__spanRow__2pfr+";
export const statsLine = "CommonRowMobile__statsLine__S0TUx CommonRowMobile__line__VXzFV";
export const statBlock = "CommonRowMobile__statBlock__TG-P6";
export const statCaption = "CommonRowMobile__statCaption__cvruH";
export const statValue = "CommonRowMobile__statValue__t7EuP";
export const creditConditionStatBlock = "CommonRowMobile__creditConditionStatBlock__lBbwU";
export const dateOpenedStatBlock = "CommonRowMobile__dateOpenedStatBlock__aX5vZ";